export default __webpack_public_path__ + "static/reco@2x-6d2e63d3f0b7797964f1ec90dd3ef2da.jpg";